import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';

import PresentationList, { PresentationListProps } from '../lists/PresentationList';
import * as ListComponents from '../lists/index';

import styles from '../../styles/blocks/items-block.module.css';

interface ItemsBlockProps extends PresentationListProps {
    title?: React.ReactNode;
    itemsType: string;
    cardType?: string | null;
    withoutMaxWidth?: boolean;
    className?: string | null;
    titleClassName?: string | null;
}

function ItemsBlock({
    title = null,
    itemsType = null,
    cardType = null,
    withoutMaxWidth = false,
    className = null,
    titleClassName = null,
    ...props
}: ItemsBlockProps) {
    const ListComponent =
        itemsType !== null
            ? getComponentFromName(ListComponents, itemsType, PresentationList)
            : PresentationList;
    return ListComponent !== null ? (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withoutMaxWidth]: withoutMaxWidth,
                    [styles.withShadow]: cardType === 'over',
                },
                className,
            ])}
        >
            {title !== null ? (
                <div className={classNames([styles.title, titleClassName])}>{title}</div>
            ) : null}
            <ListComponent
                cardType={cardType}
                itemsClassName={styles.items}
                itemClassName={styles.item}
                cardClassName={styles.card}
                {...props}
            />
        </div>
    ) : null;
}

export default ItemsBlock;
